export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-trip-progress-1200-01b37a824bef4efe01e97ffb02ada16c.webp";